export default class NotificationServiceForBanners {
  constructor() {
    this.subscribers = new Set(); // Using Set instead of array
  }

  subscribe(subscriber) {
    this.subscribers.add(subscriber); // O(1) insertion (faster than array spread)
  }

  unsubscribe(subscriber) {
    this.subscribers.delete(subscriber); // O(1) removal (faster than filter)
  }

  publish(payload) {
    this.subscribers.forEach(subscriber => subscriber(payload)); // Same iteration
  }
}